<section class="summary u-text-center u-margin-top-small max-width" [ngStyle]="{'background-color': commentcardStyles.SurveyBackgroundColor}">
  
  @if(descriptionHtml && isdatavalid && isvalid){
    <p [innerHTML]="descriptionHtml"></p>
  }@else{
    @if (isdatavalid && isvalid) {
      <span [ngStyle]="{'color':commentcardStyles.MainContentTextColor}">
        <!-- <p class="summary__message">Thank You for joining with us <span class="text-bold">{{getvalue(getsurveyelement?.Payload?.Contact?.GuestTitle)}} {{ getsurveyelement?.Payload?.Contact?.FirstName }} {{  getsurveyelement?.Payload?.Contact?.LastName }}</span> for the <span class="text-bold">{{getsurveyelement?.Payload?.SpecialMealName}}</span> <ng-container @if (getsurveyelement?.isActivity) {> activity  </ng-container> } on <span class="text-bold"> {{(getsurveyelement?.Payload?.ReservedFor ? getsurveyelement?.Payload?.ReservedFor : getsurveyelement?.Payload?.ArrivedAt) | localizeDate:'Do MMMM, ddd'}} </span></p>
        <p class="summary__location">{{getsurveyelement?.Payload?.Contact?.VisitStats[0].RestaurantName}}</p>
        <p class="summary__message-sub text-bold">We are listening! Help us to make the experience even better!</p> -->
        <p [innerHTML]="IntroText"></p>
      </span>
    }
  }
  @if (!isdatavalid) {
    <span>
      <p class="summary__message-sub text-bold">Invalid Data !!!</p>
    </span>
  }
  @if (isdatavalid && !isvalid) {
    <span>
      <p class="summary__message-sub text-bold">Thank You for Your Feedback. </p>
    </span>
  }

</section>
